import { Component, OnInit } from "@angular/core";
import { VisitService } from "./../services/visit.service";
import { MessageService } from "./../services/message.service";

@Component({
  selector: "app-cancel-order",
  templateUrl: "./cancel-order.component.html",
  styleUrls: ["./cancel-order.component.scss"],
})
export class CancelOrderComponent implements OnInit {
  constructor(
    private visitService: VisitService,
    private msg: MessageService
  ) {}
  isError: boolean = false;
  data: any = { orderNumber: null };
  ngOnInit() {}

  preceedCancelOrder() {
    this.isError = false;
    if (!this.data.orderNumber) return (this.isError = true);
    this.visitService
      .getOrderDetails(this.data.orderNumber)
      .subscribe((result) => {
        const order = result[0];

        this.msg.alert(order.id);
      });
  }
}
